import type { Theme } from '../../themes/themes';

export const createContainerTheme = (theme: Theme): Partial<Theme> => ({
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingTop: theme.spacing(6),
          paddingBottom: theme.spacing(6),
          paddingLeft: theme.spacing(8),
          paddingRight: theme.spacing(8),

          backgroundColor: theme.palette.background.default,

          [theme.breakpoints.between('sm', 'lg')]: {
            paddingLeft: theme.spacing(5),
            paddingRight: theme.spacing(5),
            maxWidth: 636,
          },

          [theme.breakpoints.up('lg')]: {
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10),
            paddingLeft: theme.spacing(12),
            paddingRight: theme.spacing(12),
          },
        },
        disableGutters: {
          paddingLeft: 0,
          paddingRight: 0,
          paddingTop: 0,
          paddingBottom: 0,

          backgroundColor: theme.palette.background.default,

          [theme.breakpoints.between('sm', 'lg')]: {
            paddingLeft: 0,
            paddingRight: 0,
          },

          [theme.breakpoints.up('lg')]: {
            paddingLeft: 0,
            paddingRight: 0,
            paddingTop: 0,
            paddingBottom: 0,
          },
        },
      },
    },
  },
});
